<ion-content>
  <div class="syncDismissBtn" (click)="dismiss()" *ngIf="showCloseDialogIcon">
    <ion-icon name="alberta-cancel"></ion-icon>
  </div>
  <swiper-container [modules]="swiperModules" #slider *ngIf="showIndicator">
    <swiper-slide class="wrapper">
      <div class="motto-wrapper safe-area-inset" [ngStyle]="style">
        <div class="motto">
          <div class="mottoHeader">
            <div>{{ 'sync.quote' | translate }}</div>
            <div>{{ 'sync.ofTheDay' | translate }}</div>
          </div>
          <div class="mottoQuoteText">"{{ quote.quoteText }}"</div>
          <div class="mottoAuthor">&mdash; {{ quote.author }}</div>
        </div>
        <div class="loadingIndicatorMotto" (click)="goToDataPage()">
          <ion-spinner name="circles" color="light"></ion-spinner> {{ 'sync.syncStatus' | translate }}
          <ion-icon name="alberta-arrow-right"></ion-icon>
        </div>
      </div>
    </swiper-slide>

    <swiper-slide class="progress">
      <div class="progress-wrapper safe-area-inset">
        <div class="syncItem-wrapper">
          <div class="syncItem" *ngFor="let progressItem of progressItems | progressItemSortPipe">
            <div class="syncItemTitle">{{ 'entities.' + progressItem.title | translate }}</div>
            <div class="syncItemProgress">
              <ion-spinner
                name="circles"
                color="light"
                *ngIf="progressItem.progress < progressItem.total"
              ></ion-spinner>
              {{ progressItem.progress }} / {{ progressItem.total }}
            </div>
          </div>
        </div>
        <div class="loadingIndicatorProgress" (click)="goToMottoPage()">
          <ion-icon name="alberta-arrow-left"></ion-icon> {{ 'sync.toTheQuote' | translate }}
        </div>
      </div>
    </swiper-slide>
  </swiper-container>
</ion-content>
